export default __webpack_public_path__ + "static/media/bw.4e6a83a2.svg";